export const groupByOptions = ['none', 'user', 'facility'] as const
export const intervalOptions = ['none', 'week', 'month', 'year'] as const

export type GroupByValue = {
  group: typeof groupByOptions[number]
  interval: typeof intervalOptions[number]
}
